import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {Badge} from 'shared/models/badges/badge';
import {BadgeType} from 'shared/models/badges/badge-type';
import {BadgeTypeFactoryService} from 'shared/badges/services/badge-type-factory.service';
import {IBadgesDetailsRepository} from '../repositories/badges-details.repository.interface';

@Injectable()
export class BadgesDetailsService {

  constructor(@Inject('IBadgesDetailsRepository') private badgesDetailsRepository: IBadgesDetailsRepository,
              private badgeTypeFactoryService: BadgeTypeFactoryService) { }

  public getBadge(id: string): Observable<Badge> {
    return this.badgesDetailsRepository.getBadge(id)
      .map((badge: Badge) => {
        const badgeType: BadgeType = this.badgeTypeFactoryService
          .createBadgeType(badge.type.name, badge.type);
        badge.type = badgeType;

        return badge;
      });
  }

  public saveBadge(badge: Badge): Observable<Badge> {
    return this.badgesDetailsRepository.saveBadge(badge);
  }

  public updateBadge(badge: Badge): Observable<Badge> {
    return this.badgesDetailsRepository.updateBadge(badge);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/badges/badges-details/services/badges-details.service.ts